import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { Story } from './pages/Story';
import { Services } from './pages/Services';
import { MeditationBetweenWorlds } from './pages/MeditationBetweenWorlds';
import { SoundInfusedRenewal } from './pages/SoundInfusedRenewal';
import { Sopotje } from './pages/Sopotje';
import { Blog } from './pages/Blog';
import { Testimonies } from './pages/Testimonies';
import { Podcasts } from './pages/Podcasts';
import { Meditation } from './pages/Meditation';
import { CreativeCorner } from './pages/CreativeCorner';
import { Contact } from './pages/Contact';
import { useScreenInit } from './useScreenInit';
import { ScrollToTop } from './components/ScrollToTop';
function AppContent() {
  useScreenInit();
  return <>
      <ScrollToTop data-id="element-0" />
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/milangela" element={<Story data-id="element-5" />} data-id="element-4" />
        <Route path="/services" element={<Services data-id="element-7" />} data-id="element-6" />
        <Route path="/services/meditation-between-worlds" element={<MeditationBetweenWorlds data-id="element-9" />} data-id="element-8" />
        <Route path="/services/sound-infused-renewal" element={<SoundInfusedRenewal data-id="element-11" />} data-id="element-10" />
        <Route path="/services/sopotje" element={<Sopotje data-id="element-13" />} data-id="element-12" />
        <Route path="/blog" element={<Blog data-id="element-15" />} data-id="element-14" />
        <Route path="/testimonies" element={<Testimonies data-id="element-17" />} data-id="element-16" />
        <Route path="/podcasts" element={<Podcasts data-id="element-19" />} data-id="element-18" />
        <Route path="/meditation" element={<Meditation data-id="element-21" />} data-id="element-20" />
        <Route path="/creative-corner" element={<CreativeCorner data-id="element-23" />} data-id="element-22" />
        <Route path="/contact" element={<Contact data-id="element-25" />} data-id="element-24" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-27" />} data-id="element-26" />
      </Routes>
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-28">
      <AppContent data-id="element-29" />
    </BrowserRouter>;
}